import React from 'react'

function Consignment() {
    return (
        <div>
            Consignment
        </div>
    )
}

export default Consignment
